import PropTypes from "prop-types";
import ShowAllLikes from "./ShowAllLikes";

// "Likes" popup of a comment: the same popup as a post's likes, listing `comment.liked_by`.
// comment_id is still accepted from SingleComment; the list comes with the comment itself.
export default function ShowCommentLikes({
  openLikesModal,
  setOpenLikesModal,
  comment,
}) {
  return (
    <ShowAllLikes
      openLikesModal={openLikesModal}
      handleCloseSimpleBox={() => setOpenLikesModal(false)}
      feeds_list={comment}
    />
  );
}

ShowCommentLikes.propTypes = {
  openLikesModal: PropTypes.bool,
  setOpenLikesModal: PropTypes.func.isRequired,
  comment: PropTypes.object,
};
